import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedComponentsModule } from '../directives/shared-components.module';
import { IconFontModule } from '../icon-font/icon-font.module';
import { DialogActionsDirective, DialogComponent, DialogFooterDirective } from './dialog.component';

@NgModule({
    imports: [
        CommonModule,
        IconFontModule,
        SharedComponentsModule
    ],
    declarations: [
        DialogComponent,
        DialogActionsDirective,
        DialogFooterDirective
    ],
    exports: [
        DialogComponent,
        DialogActionsDirective,
        DialogFooterDirective
    ]
})
export class DialogModule {
}
